export default __webpack_public_path__ + "static/media/cardless-withdrawal.fe56eb11.svg";